module.exports = __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/stitcher-b135738f376fb900e36725de90d4ae7d.svg";